import { useCallback } from 'react';
import { useLoginUrl } from 'b2b-apps/shop/context/hooks';
import { simulateLinkClick } from 'b2b-apps/shop/routes/utils/url';

export type UseLoginActionType = (reason?: string) => void;

export const useLoginAction = (): UseLoginActionType => {
  const getLoginUrl = useLoginUrl();

  return useCallback(
    (reason?: string) => {
      simulateLinkClick(getLoginUrl(reason));
    },
    [getLoginUrl],
  );
};
